module.exports = __webpack_public_path__ + "static/media/high.c916bdf6.jpeg";